module.exports = __webpack_public_path__ + "static/media/bx-user-circle.37028b3e.svg";